import { motion } from "framer-motion";
import { systemWhite } from "../../../constants";
import { createStyledElement } from "../../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

const getCardWidth = () => {
  if (typeof window === "undefined") {
    return 200;
  }

  if (window.innerWidth <= 360) {
    return "min(100%, 135px)";
  }

  if (window.innerWidth <= 768) {
    return "min(100%, 163px)";
  }

  if (window.innerWidth <= 1024) {
    return "min(100%, 180px)";
  }

  return 200;
};

export const CardContainer = createStyledElement(motion.div, () => ({
  width: getCardWidth(),
  minHeight: isMobileViewport() ? 190 : 200,
  height: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  textAlign: "center",
  overflow: "hidden",
  boxShadow: "0 8px 24px 0 #000C2814",
  padding: isMobileViewport() ? "28px 16px 18px" : "40px 24px 16px",
  gap: isMobileViewport() ? 14 : 20,
  borderRadius: 16,
  backgroundColor: systemWhite,
}));

export const CardText = createStyledElement("span", {
  font: '400 clamp(13px, 3.8vw, 16px)/1.35 "Roboto", sans-serif',
  textAlign: "center",
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  whiteSpace: "normal",
  hyphens: "auto",
});

export const CardIcon = createStyledElement("img", {
  width: "clamp(30px, 10vw, 40px)",
});
